// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"3548dee1","401":"bcb511de","526":"4089be56","562":"5db55c99","649":"4e861e34","662":"1e81cbc8","672":"7a672df0","825":"66f6b926","855":"ab02ad61"}[chunkId] + ".chunk.css";
};